(function () {
  console.log("Fast AJAX navigation loaded");

  const MAIN_SELECTOR = "#MainContent";
  const CACHE_LIMIT = 40;
  const cache = new Map();
  const prefetching = new Map();

  let isNavigating = false;
  let currentController = null;

  function normalizeUrl(url) {
    const parsed = new URL(url, window.location.origin);
    parsed.hash = "";
    return parsed.toString();
  }

  function isModifiedClick(event) {
    return (
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0
    );
  }

  function shouldSkipLink(link) {
    if (!link) return true;

    const href = link.getAttribute("href");

    if (!href) return true;
    if (href.startsWith("#")) return true;
    if (href.startsWith("mailto:")) return true;
    if (href.startsWith("tel:")) return true;
    if (href.startsWith("javascript:")) return true;

    if (link.target && link.target !== "_self") return true;
    if (link.hasAttribute("download")) return true;
    if (link.closest("[data-no-ajax]")) return true;

    let url;

    try {
      url = new URL(link.href, window.location.origin);
    } catch (error) {
      return true;
    }

    if (url.origin !== window.location.origin) return true;

    const path = url.pathname;

    const blockedPaths = [
      "/cart",
      "/checkout",
      "/account",
      "/search",
      "/challenge",
      "/apps",
      "/admin",
      "/policies"
    ];

    if (blockedPaths.some((blockedPath) => path.startsWith(blockedPath))) {
      return true;
    }

    if (url.searchParams.has("view")) return true;
    if (url.searchParams.has("section_id")) return true;
    if (url.searchParams.has("filter.v")) return true;
    if (url.searchParams.has("sort_by")) return true;
    if (url.searchParams.has("q")) return true;

    return false;
  }

  function cacheSet(url, html) {
    if (cache.has(url)) {
      cache.delete(url);
    }

    cache.set(url, html);

    if (cache.size > CACHE_LIMIT) {
      const firstKey = cache.keys().next().value;
      cache.delete(firstKey);
    }
  }

  function getCachedPage(url) {
    return cache.get(normalizeUrl(url)) || null;
  }

  async function fetchPage(url, signal) {
    const normalizedUrl = normalizeUrl(url);

    if (cache.has(normalizedUrl)) {
      return cache.get(normalizedUrl);
    }

    const response = await fetch(normalizedUrl, {
      method: "GET",
      credentials: "same-origin",
      signal,
      headers: {
        "Accept": "text/html",
        "X-Requested-With": "XMLHttpRequest"
      }
    });

    if (!response.ok) {
      throw new Error("Page fetch failed");
    }

    const html = await response.text();
    cacheSet(normalizedUrl, html);
    return html;
  }

  function updateHead(newDocument) {
    const newTitle = newDocument.querySelector("title");

    if (newTitle) {
      document.title = newTitle.textContent;
    }

    const currentCanonical = document.querySelector("link[rel='canonical']");
    const newCanonical = newDocument.querySelector("link[rel='canonical']");

    if (currentCanonical && newCanonical) {
      currentCanonical.setAttribute("href", newCanonical.getAttribute("href"));
    }

    const currentDescription = document.querySelector("meta[name='description']");
    const newDescription = newDocument.querySelector("meta[name='description']");

    if (currentDescription && newDescription) {
      currentDescription.setAttribute(
        "content",
        newDescription.getAttribute("content") || ""
      );
    }

    const currentOgTitle = document.querySelector("meta[property='og:title']");
    const newOgTitle = newDocument.querySelector("meta[property='og:title']");

    if (currentOgTitle && newOgTitle) {
      currentOgTitle.setAttribute("content", newOgTitle.getAttribute("content") || "");
    }

    const currentOgDescription = document.querySelector("meta[property='og:description']");
    const newOgDescription = newDocument.querySelector("meta[property='og:description']");

    if (currentOgDescription && newOgDescription) {
      currentOgDescription.setAttribute("content", newOgDescription.getAttribute("content") || "");
    }
  }

  function runMainScripts(mainElement) {
    const scripts = Array.from(mainElement.querySelectorAll("script"));

    scripts.forEach(function (oldScript) {
      const src = oldScript.getAttribute("src") || "";

      if (src.includes("canvas-bg.js")) return;
      if (src.includes("ajax-navigation.js")) return;

      const newScript = document.createElement("script");

      Array.from(oldScript.attributes).forEach(function (attr) {
        newScript.setAttribute(attr.name, attr.value);
      });

      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  function closeHeaderAndDrawers() {
    const wrap = document.getElementById("SkylrkExpandWrap");
    const toggle = document.getElementById("SkylrkExpandToggle");
    const mobileOverlay = document.getElementById("SkylrkMobileOverlay");
    const cartDrawer = document.getElementById("SkylrkCartDrawer");
    const currencySelector = document.getElementById("CustomCurrencySelector");

    if (wrap) {
      wrap.classList.remove("is-open");
    }

    if (toggle) {
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", "Open menu");
    }

    if (mobileOverlay) {
      mobileOverlay.classList.remove("is-open");
    }

    if (cartDrawer) {
      cartDrawer.classList.remove("is-open");
      cartDrawer.setAttribute("aria-hidden", "true");
    }

    if (currencySelector) {
      currencySelector.classList.remove("is-open");
    }

    document.body.classList.remove("skylrk-cart-open");
  }

  function reinitializeTheme() {
    document.dispatchEvent(
      new CustomEvent("ajax:navigation:complete", {
        bubbles: true
      })
    );

    window.dispatchEvent(new Event("resize"));
    window.dispatchEvent(new Event("scroll"));

    if (
      window.skylrkGlobalCanvasBg &&
      typeof window.skylrkGlobalCanvasBg.resize === "function"
    ) {
      window.skylrkGlobalCanvasBg.resize();
    }
  }

  function setLoadingState(isLoading) {
    document.documentElement.classList.toggle("ajax-page-loading", isLoading);
  }

  function startFadeOut() {
    document.documentElement.classList.remove("ajax-page-ready");
    document.documentElement.classList.remove("ajax-page-entering");
    document.documentElement.classList.add("ajax-page-leaving");
  }

  function startFadeIn() {
    document.documentElement.classList.remove("ajax-page-leaving");
    document.documentElement.classList.add("ajax-page-entering");

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.documentElement.classList.remove("ajax-page-entering");
        document.documentElement.classList.add("ajax-page-ready");

        setTimeout(function () {
          document.documentElement.classList.remove("ajax-page-ready");
        }, 260);
      });
    });
  }

  function replacePageContent(html, targetUrl, options = {}) {
    const currentMain = document.querySelector(MAIN_SELECTOR);
    const newDocument = new DOMParser().parseFromString(html, "text/html");
    const newMain = newDocument.querySelector(MAIN_SELECTOR);

    if (!currentMain || !newMain) {
      window.location.href = targetUrl;
      return false;
    }

    updateHead(newDocument);

    currentMain.replaceChildren(...Array.from(newMain.childNodes));

    if (!options.isPopState) {
      history.pushState(
        {
          ajaxNavigation: true,
          url: targetUrl
        },
        "",
        targetUrl
      );
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });

    runMainScripts(currentMain);
    reinitializeTheme();
    startFadeIn();

    return true;
  }

  async function navigateTo(url, options = {}) {
    const currentMain = document.querySelector(MAIN_SELECTOR);

    if (!currentMain) {
      window.location.href = url;
      return;
    }

    const targetUrl = normalizeUrl(url);
    const currentUrl = normalizeUrl(window.location.href);

    if (targetUrl === currentUrl && !options.isPopState && !options.force) return;
    if (isNavigating) return;

    isNavigating = true;

    closeHeaderAndDrawers();
    startFadeOut();

    if (currentController) {
      currentController.abort();
    }

    currentController = new AbortController();

    try {
      const cachedHtml = getCachedPage(targetUrl);

      if (cachedHtml) {
        replacePageContent(cachedHtml, targetUrl, options);
        return;
      }

      setLoadingState(true);

      const html = await fetchPage(targetUrl, currentController.signal);
      const replaced = replacePageContent(html, targetUrl, options);

      if (!replaced) {
        window.location.href = targetUrl;
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error("AJAX navigation failed. Falling back to normal load:", error);
        window.location.href = targetUrl;
      }
    } finally {
      setLoadingState(false);
      isNavigating = false;
      currentController = null;
    }
  }

  function prefetchLink(link) {
    if (shouldSkipLink(link)) return;

    const url = normalizeUrl(link.href);

    if (cache.has(url)) return;
    if (prefetching.has(url)) return;

    const controller = new AbortController();
    prefetching.set(url, controller);

    fetchPage(url, controller.signal)
      .catch(function () {})
      .finally(function () {
        prefetching.delete(url);
      });
  }

  function prefetchImportantLinks() {
    const links = Array.from(document.querySelectorAll("a[href]"));

    links.slice(0, 30).forEach(function (link) {
      if (!shouldSkipLink(link)) {
        prefetchLink(link);
      }
    });
  }

  document.addEventListener(
    "mouseover",
    function (event) {
      const link = event.target.closest("a");

      if (!link) return;

      prefetchLink(link);
    },
    {
      passive: true
    }
  );

  document.addEventListener(
    "touchstart",
    function (event) {
      const link = event.target.closest("a");

      if (!link) return;

      prefetchLink(link);
    },
    {
      passive: true
    }
  );

  document.addEventListener(
    "mousedown",
    function (event) {
      const link = event.target.closest("a");

      if (!link) return;

      prefetchLink(link);
    },
    {
      passive: true
    }
  );

  document.addEventListener("click", function (event) {
    if (isModifiedClick(event)) return;

    const link = event.target.closest("a");

    if (!link) return;

    if (shouldSkipLink(link)) return;

    event.preventDefault();
    event.stopPropagation();

    navigateTo(link.href);
  });

  window.addEventListener("popstate", function () {
    navigateTo(window.location.href, {
      isPopState: true,
      force: true
    });
  });

  document.addEventListener("submit", function (event) {
    const form = event.target;

    if (!form || form.tagName !== "FORM") return;

    form.setAttribute("data-no-ajax", "true");
  });

  history.replaceState(
    {
      ajaxNavigation: true,
      url: window.location.href
    },
    "",
    window.location.href
  );

  window.addEventListener("load", function () {
    setTimeout(prefetchImportantLinks, 250);
  });

  document.addEventListener("ajax:navigation:complete", function () {
    setTimeout(prefetchImportantLinks, 250);
  });
})();